/**
 * Element to which sdk iframes are appended, configurable via scDK init.
 * Kept outside WindowManager so modules that only need the render target
 * (eg las loader) don't pull connect frame messaging into their bundle.
 */
const windowTarget: { elementOrSelector: string | HTMLElement } = {
  elementOrSelector: 'body',
};

export default windowTarget;
